import { render, staticRenderFns } from "./ButtonLoader.vue?vue&type=template&id=62d4e5f8&scoped=true&"
import script from "./ButtonLoader.vue?vue&type=script&lang=js&"
export * from "./ButtonLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d4e5f8",
  null
  
)

export default component.exports